import GatsbyLink from "gatsby-link"
import React from "react"
import Box from "./Box"
import Container from "./Container"
import Flex from "./Flex"
import Link from "./Link"
import BLIcon from "../images/bl-icon.svg"
import Image from "./Image"
import { string } from "prop-types"

const HeaderLink = props => (
  <Link target="_blank" rel="noopener noreferrer" {...props} />
)

function Header({ title, link, ...props }) {
  return (
    <Box py={[4]} borderBottom="1px solid" bg="white" borderColor="UI Dark">
      <Container>
        <Flex alignItems="center">
          <Link is={GatsbyLink} to={link}>
            <Box display={["inline-block"]}>
              <Image src={BLIcon} width={32} alt="Bukalapak" />
            </Box>
          </Link>

          <Box
            display={["inline-block"]}
            ml={3}
            width={"1px"}
            height={"32px"}
            bg="UI Dark"
          />

          <Link is={GatsbyLink} to={link} fontSize={2} fontWeight={600}>
            <Box ml={[3]} display={["inline-block"]}>
              {title}
            </Box>
          </Link>

          <Box mx="auto" />

          <HeaderLink href="https://blds.bukalapak.design/">
            <Box display={["none", "inline-block"]}>blds.bukalapak.design</Box>
          </HeaderLink>
        </Flex>
      </Container>
    </Box>
  )
}

Header.propTypes = {
  title: string,
}

Header.defaultProps = {
  title: "Page Name",
}

export default Header



// WEBPACK FOOTER //
// ./src/components/Header.js